import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68966908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modern-form-container" }
const _hoisted_2 = { class: "form-progress mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Informations", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Classification", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "3", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fichier", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "4", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmation", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "card modern-card" }
const _hoisted_16 = { class: "card-body p-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Informations du Document ")
], -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "text-black fw-semibold mb-10" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "text-black fw-semibold mb-10" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "modern-input-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "titre",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Réference"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "modern-input-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "titre",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Titre"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "modern-input-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "sousTitre",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Sous Titre ")
], -1))
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = { class: "modern-input-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "anneePublication",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode(" Année de Publication"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "modern-input-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "version",
  class: "modern-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Version"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "modern-select-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Langue "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_44 = { class: "col-md-12 mb-12" }
const _hoisted_45 = { class: "modern-input-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, " Résumé / Description ", -1))
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tags me-2" }),
  /*#__PURE__*/_createTextVNode(" Classification du Document ")
], -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = { class: "modern-select-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Direction "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = { class: "modern-select-group" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Service "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "modern-select-group" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Auteur "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      class: "btn btn-primary py-1 px-2 fs-12",
      style: {"cursor":"pointer"},
      "data-bs-toggle": "modal",
      "data-bs-target": "#AddElementModal",
      title: "Ajouter un nouvel auteur"
    }, " Nouveau ")
  ])
], -1))
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = { class: "modern-select-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Type de fichier "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = { class: "modern-select-group" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Catégorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_65 = { class: "col-md-4" }
const _hoisted_66 = { class: "modern-select-group" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Maison d'Edition "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      class: "btn btn-primary py-1 px-2 fs-12",
      style: {"cursor":"pointer"},
      title: "Ajouter une nouvelle maison d'édition"
    }, " Nouveau ")
  ])
], -1))
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = { class: "modern-select-group" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder me-2" }),
  /*#__PURE__*/_createTextVNode(" Secteur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = { class: "modern-select-group" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Genre "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ])
], -1))
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "modern-select-group" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modern-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Mot clé associé "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      class: "btn btn-primary py-1 px-2 fs-12",
      style: {"cursor":"pointer"},
      title: "Ajouter un nouveau mot clé"
    }, " Nouveau ")
  ])
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-upload-alt me-2" }),
  /*#__PURE__*/_createTextVNode(" Chargement du Document ")
], -1))
const _hoisted_78 = {
  key: 0,
  class: "upload-content"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-upload-alt upload-icon" }, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Glissez-déposez votre fichier ici", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "ou", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder-open me-2" }, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block mt-2" }, " Formats acceptés: PDF, DOC, DOCX, TXT, JPG, PNG, GIF, WEBP, MP4, MOV, AVI, MKV, WEBM (Max: 10MB) ", -1))
const _hoisted_84 = {
  key: 1,
  class: "file-preview"
}
const _hoisted_85 = { class: "file-info" }
const _hoisted_86 = {
  key: 0,
  class: "fas fa-file-alt file-icon"
}
const _hoisted_87 = {
  key: 1,
  class: "fas fa-image file-icon text-success"
}
const _hoisted_88 = {
  key: 2,
  class: "fas fa-video file-icon text-primary"
}
const _hoisted_89 = { class: "file-details" }
const _hoisted_90 = { class: "text-muted" }
const _hoisted_91 = {
  key: 0,
  class: "badge bg-primary ms-2 text-white"
}
const _hoisted_92 = {
  key: 1,
  class: "badge bg-primary ms-2 text-white"
}
const _hoisted_93 = {
  key: 2,
  class: "badge bg-primary ms-2 text-white"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-minus p-1" }, null, -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = {
  key: 0,
  class: "image-preview mt-3"
}
const _hoisted_97 = ["src"]
const _hoisted_98 = {
  key: 1,
  class: "video-preview mt-3"
}
const _hoisted_99 = ["src"]
const _hoisted_100 = {
  key: 2,
  class: "upload-progress"
}
const _hoisted_101 = { class: "progress" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "step-title mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Confirmation ")
], -1))
const _hoisted_103 = { class: "confirmation-card" }
const _hoisted_104 = { class: "summary-section" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode("INFORMATION DU DOCUMENT")
], -1))
const _hoisted_106 = { class: "table mb-4" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Réference :")
], -1))
const _hoisted_108 = { class: "p-2" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Titre :")
], -1))
const _hoisted_110 = { class: "p-2" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sous Titre :")
], -1))
const _hoisted_112 = { class: "p-2" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Version :")
], -1))
const _hoisted_114 = { class: "p-2" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Année :")
], -1))
const _hoisted_116 = { class: "p-2" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Auteur :")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "p-2" })
], -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode("CLASSIFICATION")
], -1))
const _hoisted_119 = { class: "table mb-4" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Direction :")
], -1))
const _hoisted_121 = { class: "p-2" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Service :")
], -1))
const _hoisted_123 = { class: "p-2" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Type de Fichier :")
], -1))
const _hoisted_125 = { class: "p-2" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Catégorie :")
], -1))
const _hoisted_127 = { class: "p-2" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Maison d'Edition :")
], -1))
const _hoisted_129 = { class: "p-2" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book me-2" }),
  /*#__PURE__*/_createTextVNode("FICHIER")
], -1))
const _hoisted_131 = { class: "table mb-4" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-25 p-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nom :")
], -1))
const _hoisted_133 = { class: "p-2" }
const _hoisted_134 = { class: "form-navigation mt-4" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1))
const _hoisted_136 = ["disabled"]
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right ms-2" }, null, -1))
const _hoisted_138 = ["disabled"]
const _hoisted_139 = {
  key: 0,
  class: "fas fa-plus me-2"
}
const _hoisted_140 = {
  key: 1,
  class: "fas fa-spinner fa-spin me-2"
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times me-2" }, null, -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddAuteurModal = _resolveComponent("AddAuteurModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["step-container", `step-${_ctx.currentStep}`])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["step col-md-3", { active: _ctx.currentStep >= 1, completed: _ctx.currentStep > 1 }])
          }, _hoisted_5, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["step col-md-3", { active: _ctx.currentStep >= 2, completed: _ctx.currentStep > 2 }])
          }, _hoisted_8, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["step col-md-3", { active: _ctx.currentStep >= 3, completed: _ctx.currentStep > 3 }])
          }, _hoisted_11, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["step col-md-3", { active: _ctx.currentStep >= 4 }])
          }, _hoisted_14, 2)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Form, {
            ref: "documentForm",
            onSubmit: _ctx.addDocument,
            "validation-schema": _ctx.documentSchema,
            "initial-values": _ctx.formData
          }, {
            default: _withCtx(({ setFieldValue }) => [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 1 }, "step-content"])
              }, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, [
                        _createVNode(_component_Field, {
                          name: "estTelechargeable",
                          type: "checkbox",
                          value: true,
                          "unchecked-value": false,
                          class: "form-check-input shadow-none"
                        }),
                        _createTextVNode(" Est Téléchargeable ? ")
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "estTelechargeable",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, [
                        _createVNode(_component_Field, {
                          name: "estPublique",
                          type: "checkbox",
                          value: true,
                          "unchecked-value": false,
                          class: "form-check-input shadow-none"
                        }),
                        _createTextVNode(" Est Publique ? ")
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "estPublique",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_Field, {
                        name: "reference",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                        placeholder: "Référence du document",
                        "onUpdate:modelValue": (value) => { setFieldValue('reference', value); 
                        _ctx.updateFormField('reference', value); }
                      }, null, 8, ["onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "reference",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_Field, {
                        name: "titre",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                        placeholder: "Entrer le titre du document",
                        "onUpdate:modelValue": (value) => { setFieldValue('titre', value); 
                        _ctx.updateFormField('titre', value); }
                      }, null, 8, ["onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "titre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_Field, {
                        name: "sousTitre",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                        placeholder: "Entrer le sous titre du document",
                        "onUpdate:modelValue": (value) => { setFieldValue('sousTitre', value); _ctx.updateFormField('sousTitre', value); }
                      }, null, 8, ["onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "sousTitre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_Field, {
                        name: "anneePublication",
                        type: "number",
                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                        placeholder: "2025",
                        "onUpdate:modelValue": (value) => { setFieldValue('anneePublication', value); _ctx.updateFormField('anneePublication', value); }
                      }, null, 8, ["onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "anneePublication",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_Field, {
                        name: "version",
                        type: "number",
                        value: 1,
                        class: "form-control shadow-none fs-md-15 text-black modern-input",
                        placeholder: "Entrer la version du document",
                        "onUpdate:modelValue": (value) => { setFieldValue('version', value); _ctx.updateFormField('version', value); }
                      }, null, 8, ["onUpdate:modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "version",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_Field, {
                        name: "langue",
                        type: "text"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            options: _ctx.langueOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner la langue",
                            label: "label",
                            "track-by": "label",
                            onChange: (value) => { setFieldValue('langue', value); _ctx.updateFormField('langue', value); },
                            class: "modern-multiselect"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "langue",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_Field, { name: "description" }, {
                        default: _withCtx(({ field }) => [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            class: "form-control shadow-none rounded-0 text-black modern-input",
                            cols: "20",
                            rows: "4",
                            placeholder: "Entrer la description du document"
                          }, "\n                        ", 8, _hoisted_47), [
                            [_vModelText, field.value]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "description",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 2 }, "step-content"])
              }, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode(_component_Field, { name: "direction" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.directionOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner la direction",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('direction', value); _ctx.updateFormField('direction', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "direction",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_Field, { name: "service" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.filteredServiceOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner le service",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('service', value); _ctx.updateFormField('service', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "service",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode(_component_Field, {
                        name: "auteur",
                        modelValue: _ctx.auteurSelected,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.auteurSelected) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.auteurOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner l'auteur",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('auteur', value); _ctx.updateFormField('auteur', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "auteur",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_Field, { name: "typeFichier" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.typeFichierOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner le type de fichier",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('typeFichier', value); _ctx.updateFormField('typeFichier', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "typeFichier",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createVNode(_component_Field, { name: "categorie" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.categorieOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner la catégorie",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('categorie', value); _ctx.updateFormField('categorie', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "categorie",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createVNode(_component_Field, { name: "maisonEdition" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.maisonEditionOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner la maison d'Edition",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('maisonEdition', value); _ctx.updateFormField('maisonEdition', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "maisonEdition",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createVNode(_component_Field, { name: "secteur" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.secteurOptions,
                            "preserve-search": true,
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner le secteur",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('secteur', value); _ctx.updateFormField('secteur', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "secteur",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createVNode(_component_Field, { name: "genre" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.genreOptions,
                            "preserve-search": true,
                            mode: "tags",
                            multiple: false,
                            searchable: true,
                            placeholder: "Sélectionner le genre",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('genre', value); _ctx.updateFormField('genre', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "genre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createVNode(_component_Field, { name: "tag" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            appendToBody: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.tagOptions,
                            "preserve-search": true,
                            multiple: false,
                            mode: "tags",
                            searchable: true,
                            placeholder: "Sélectionner un mot clé",
                            label: "label",
                            "track-by": "label",
                            class: "modern-multiselect",
                            onChange: (value) => { setFieldValue('tag', value); _ctx.updateFormField('tag', value); }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ErrorMessage, {
                        name: "tag",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 3 }, "step-content"])
              }, [
                _hoisted_77,
                _createElementVNode("div", {
                  class: _normalizeClass(["file-upload-zone", { 'drag-over': _ctx.dragOver }]),
                  onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFileDrop && _ctx.handleFileDrop(...args)), ["prevent"])),
                  onDragover: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.dragOver = true), ["prevent"])),
                  onDragleave: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.dragOver = false), ["prevent"]))
                }, [
                  (!_ctx.selectedFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _hoisted_79,
                        _hoisted_80,
                        _hoisted_81,
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileInput?.click()))
                        }, [
                          _hoisted_82,
                          _createTextVNode(" Parcourir les fichiers ")
                        ]),
                        _createElementVNode("input", {
                          ref: "fileInput",
                          type: "file",
                          name: "nomFichier",
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
                          accept: ".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.webp,.bmp,.mp4,.mov,.avi,.mkv,.webm,.flv,.wmv",
                          style: {"display":"none"}
                        }, null, 544),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomFichier",
                          class: "text-danger mt-2"
                        }),
                        _hoisted_83
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          (!_ctx.isImageFile(_ctx.selectedFile) && !_ctx.isVideoFile(_ctx.selectedFile))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_86))
                            : _createCommentVNode("", true),
                          (_ctx.isImageFile(_ctx.selectedFile))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_87))
                            : _createCommentVNode("", true),
                          (_ctx.isVideoFile(_ctx.selectedFile))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_88))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("h6", null, _toDisplayString(_ctx.selectedFile.name), 1),
                            _createElementVNode("small", _hoisted_90, _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)), 1),
                            (_ctx.isImageFile(_ctx.selectedFile))
                              ? (_openBlock(), _createElementBlock("small", _hoisted_91, "Image"))
                              : _createCommentVNode("", true),
                            (_ctx.isVideoFile(_ctx.selectedFile))
                              ? (_openBlock(), _createElementBlock("small", _hoisted_92, "Vidéo"))
                              : _createCommentVNode("", true),
                            (!_ctx.isImageFile(_ctx.selectedFile) && !_ctx.isVideoFile(_ctx.selectedFile))
                              ? (_openBlock(), _createElementBlock("small", _hoisted_93, "Document"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-danger",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
                          }, _hoisted_95)
                        ]),
                        (_ctx.isImageFile(_ctx.selectedFile) && _ctx.imagePreviewUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _createElementVNode("img", {
                                src: _ctx.imagePreviewUrl,
                                alt: "Aperçu",
                                class: "preview-image"
                              }, null, 8, _hoisted_97)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isVideoFile(_ctx.selectedFile) && _ctx.videoPreviewUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                              _createElementVNode("video", {
                                src: _ctx.videoPreviewUrl,
                                controls: "",
                                class: "preview-video",
                                preload: "metadata"
                              }, " Votre navigateur ne supporte pas la lecture vidéo. ", 8, _hoisted_99)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.uploadProgress > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("div", {
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: _ctx.uploadProgress + '%' })
                                }, null, 4)
                              ]),
                              _createElementVNode("small", null, _toDisplayString(_ctx.uploadProgress) + "% uploadé", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 34)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'd-none': _ctx.currentStep !== 4 }, "step-content"])
              }, [
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("table", _hoisted_106, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_107,
                          _createElementVNode("td", _hoisted_108, _toDisplayString((_ctx.formData.reference) ? _ctx.formData.reference : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_109,
                          _createElementVNode("td", _hoisted_110, _toDisplayString((_ctx.formData.titre) ? _ctx.formData.titre : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_111,
                          _createElementVNode("td", _hoisted_112, _toDisplayString((_ctx.formData.sousTitre) ? _ctx.formData.sousTitre : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_113,
                          _createElementVNode("td", _hoisted_114, _toDisplayString((_ctx.formData.version) ? _ctx.formData.version : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_115,
                          _createElementVNode("td", _hoisted_116, _toDisplayString((_ctx.formData.anneePublication) ? _ctx.formData.anneePublication : 'N/A'), 1)
                        ]),
                        _hoisted_117
                      ])
                    ]),
                    _hoisted_118,
                    _createElementVNode("table", _hoisted_119, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_120,
                          _createElementVNode("td", _hoisted_121, _toDisplayString((_ctx.formData.direction) ? _ctx.formData.direction : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_122,
                          _createElementVNode("td", _hoisted_123, _toDisplayString((_ctx.formData.service) ? _ctx.formData.service : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_124,
                          _createElementVNode("td", _hoisted_125, _toDisplayString((_ctx.formData.typeFichier) ? _ctx.formData.typeFichier : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_126,
                          _createElementVNode("td", _hoisted_127, _toDisplayString((_ctx.formData.categorie) ? _ctx.formData.categorie : 'N/A'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_128,
                          _createElementVNode("td", _hoisted_129, _toDisplayString((_ctx.formData.maisonEdition) ? _ctx.formData.maisonEdition : 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _hoisted_130,
                    _createElementVNode("table", _hoisted_131, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_132,
                          _createElementVNode("td", _hoisted_133, _toDisplayString((_ctx.selectedFile) ? _ctx.selectedFile.name : '-'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_134, [
                _createVNode(_component_Field, {
                  name: "nomFichier",
                  type: "text",
                  modelValue: _ctx.formData.nomFichier,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.nomFichier) = $event)),
                  style: {"position":"absolute","left":"-9999px","opacity":"0","pointer-events":"none"}
                }, null, 8, ["modelValue"]),
                (_ctx.currentStep > 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-outline-secondary me-3",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                    }, [
                      _hoisted_135,
                      _createTextVNode(" Précédent ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep < 4)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                      disabled: !_ctx.canProceedToNextStep
                    }, [
                      _createTextVNode(" Suivant "),
                      _hoisted_137
                    ], 8, _hoisted_136)), [
                      [_vShow, _ctx.canProceedToNextStep]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.currentStep === 4)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn btn-success me-3",
                      type: "submit",
                      disabled: _ctx.isSubmitting
                    }, [
                      (!_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_139))
                        : _createCommentVNode("", true),
                      (_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_140))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer le document'), 1)
                    ], 8, _hoisted_138))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: "/documents/liste-document",
                  class: "btn btn-danger border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                }, {
                  default: _withCtx(() => [
                    _hoisted_141,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"])
        ])
      ])
    ]),
    _hoisted_142,
    _createTextVNode(),
    _hoisted_143,
    _createVNode(_component_AddAuteurModal, { onClose: _ctx.handleClose }, null, 8, ["onClose"])
  ], 64))
}